import React from 'react';
import Hero from './components/nirf/Hero';
import Main from './components/nirf/Main';

const Nirf = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Nirf;